import { App_User } from '@/data/user_info'
import PublicService from '@/service/public'
export default (params = {}) => {
    if (!params.scene) {
        throw new Error ('缺少scene参数')
    }
    if (App_User.share_by_consultant_uid) {
        params.consultant_rids = App_User.share_by_consultant_uid
    } 
    return PublicService.getRecommendConsultant({
        ...params
    })
}